'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';
import { getCookiePreferences } from './CookieConsent';

const GA_MEASUREMENT_ID = 'G-WH6WJP6JBM'; // From Firebase config

export default function GoogleAnalytics() {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    // Check initial consent
    const prefs = getCookiePreferences();
    if (prefs?.analytics) {
      setHasConsent(true);
    }

    // Listen for consent changes
    const handleConsentChange = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail?.analytics) {
        setHasConsent(true);
      } else {
        setHasConsent(false);
        // Disable GA
        if (typeof window !== 'undefined') {
          (window as any)[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
        }
      }
    };

    window.addEventListener('cookieConsentChanged', handleConsentChange);
    return () => window.removeEventListener('cookieConsentChanged', handleConsentChange);
  }, []);

  if (!hasConsent) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            anonymize_ip: true,
            cookie_flags: 'SameSite=None;Secure'
          });
        `}
      </Script>
    </>
  );
}
